<template>
  <div id="Home_Depan">
  <nav class="navbar navbar-light bg-light static-top">
    <div class="container">
      <a class="navbar-brand" href="#">{{appName}}</a>
      <router-link class="btn btn-primary" to="/auth_user">Login</router-link>
    </div>
  </nav>

  <!-- Masthead -->
  <!-- Call to Action -->
  <section class="call-to-action text-white text-center">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-9 mx-auto">
          <h2 class="mb-4">Selamat Datang Di Website LBB Pare</h2>
        </div>
        <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">

<center>
<router-link class="btn btn-block btn-lg btn-primary" to="/register">Daftar Sekarang</router-link>
<router-link class="btn btn-block btn-lg btn-info" to="/auth">Masuk Akun</router-link>
</center>



        </div>
      </div>
    </div>
  </section>

  <!-- Testimonials -->
  <section class="testimonials text-center bg-light">
    <div class="container">
      <h2 class="mb-5">Category Pembelajaran</h2>




  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" v-for="i in data_kategory" :data="data" v-on:click="coba_key(i)" :key="i._id">
      <div class="offer offer-info">
        <div class="shape">
          <div class="shape-text">
News
          </div>
        </div>
        <div class="offer-content">
          <h3 class="lead">
            {{i.nama}}
          </h3>
          <p>
{{i.pajak}}
<br>

          </p>
        </div>
      </div>
    </div>

  </div>

    </div>
  </section>



  <!-- Footer -->
  <footer class="footer bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 h-100 text-center text-lg-left my-auto">
          <ul class="list-inline mb-2">
            <li class="list-inline-item">
              <a href="#">About</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="#">Contact</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="#">Terms of Use</a>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <a href="#">Privacy Policy</a>
            </li>
          </ul>
          <p class="text-muted small mb-4 mb-lg-0">&copy; Your Website 2019. All Rights Reserved.</p>
        </div>
        <div class="col-lg-6 h-100 text-center text-lg-right my-auto">
          <ul class="list-inline mb-0">
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-facebook fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item mr-3">
              <a href="#">
                <i class="fab fa-twitter-square fa-2x fa-fw"></i>
              </a>
            </li>
            <li class="list-inline-item">
              <a href="#">
                <i class="fab fa-instagram fa-2x fa-fw"></i>
              </a>
            </li>
          </ul>
        </div>

      </div>

    <b-modal ref="myModalRef" hide-footer title="Using Component Methods">


      <div class="offer offer-primary">
        <div class="shape">
          <div class="shape-text">
            top
          </div>
        </div>
        <div class="offer-content">
          <h3 class="lead">
            A default offer
          </h3>
          <p>
            And a little description.
            <br> and so one
          </p>
        </div>
      </div>
    </b-modal>

    </div>
  </footer>

  </div>
</template>

<script>
import { API_SERVER } from "@/config"
import { CALLAPI } from "@/functions"
export default {
  name: 'Home_Depan',
    data() {
    return {
      appName: "LBB Pare",
      data: [],
      data_kategory : [],
      errors:[],
      key_data: false,
      get_modalnya : []
    };
  },
  created() {
    CALLAPI.get('kategori/')
    .then(response => {
      this.data_kategory = response.data.data
      console.log(this.data_kategory)
    })
    .catch(function (error) {
  if (!error.status) {
    console.log('network error')
  }
 });
  },
        methods: {
            coba_key: function(title){
              this.$refs.myModalRef.show()
                 console.log(title)
                 this.get_modalnya=title

            },
      showModal() {
        this.$refs.myModalRef.show()
        this.key_data = true
      },
      hideModal() {
        this.$refs.myModalRef.hide()
      }
        }
}
</script>

<style>
.example {
  color: red;
}
.my-card
{
    position:absolute;
    left:40%;
    top:-20px;
    border-radius:50%;
}
.shape{
  border-style: solid; border-width: 0 70px 40px 0; float:right; height: 0px; width: 0px;
  -ms-transform:rotate(360deg); /* IE 9 */
  -o-transform: rotate(360deg);  /* Opera 10.5 */
  -webkit-transform:rotate(360deg); /* Safari and Chrome */
  transform:rotate(360deg);
}
.offer{
  background:#fff; border:1px solid #ddd; box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2); margin: 15px 0; overflow:hidden;
}
.offer:hover {
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform:rotate scale(1.1);
    -webkit-transition: all 0.4s ease-in-out;
-moz-transition: all 0.4s ease-in-out;
-o-transition: all 0.4s ease-in-out;
transition: all 0.4s ease-in-out;
    }
.shape {
  border-color: rgba(255,255,255,0) #d9534f rgba(255,255,255,0) rgba(255,255,255,0);
}
.offer-radius{
  border-radius:7px;
}
.offer-danger { border-color: #d9534f; }
.offer-danger .shape{
  border-color: transparent #d9534f transparent transparent;
}
.offer-success {  border-color: #5cb85c; }
.offer-success .shape{
  border-color: transparent #5cb85c transparent transparent;
}
.offer-default {  border-color: #999999; }
.offer-default .shape{
  border-color: transparent #999999 transparent transparent;
}
.offer-primary {  border-color: #428bca; }
.offer-primary .shape{
  border-color: transparent #428bca transparent transparent;
}
.offer-info { border-color: #5bc0de; }
.offer-info .shape{
  border-color: transparent #5bc0de transparent transparent;
}
.offer-warning {  border-color: #f0ad4e; }
.offer-warning .shape{
  border-color: transparent #f0ad4e transparent transparent;
}

.shape-text{
  color:#fff; font-size:12px; font-weight:bold; position:relative; right:-40px; top:2px; white-space: nowrap;
  -ms-transform:rotate(30deg); /* IE 9 */
  -o-transform: rotate(360deg);  /* Opera 10.5 */
  -webkit-transform:rotate(30deg); /* Safari and Chrome */
  transform:rotate(30deg);
}
.offer-content{
  padding:0 20px 10px;
}
@media (min-width: 487px) {
  .container {
    max-width: 750px;
  }
  .col-sm-6 {
    width: 50%;
  }
}
@media (min-width: 900px) {
  .container {
    max-width: 970px;
  }
  .col-md-4 {
    width: 33.33333333333333%;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1170px;
  }
  .col-lg-3 {
    width: 25%;
  }
  }

</style>
